import { getPropsSlot } from '../../_util/props-util';
import { computed, defineComponent } from 'vue';
import PropTypes from '../../_util/vue-types';
import { useInjectMenu } from './hooks/useMenuContext';
const menuItemGroupProps = {
    title: PropTypes.VNodeChild,
};
export default defineComponent({
    name: 'AMenuItemGroup',
    inheritAttrs: false,
    props: menuItemGroupProps,
    slots: ['title'],
    setup(props, { slots, attrs }) {
        const { prefixCls } = useInjectMenu();
        const groupPrefixCls = computed(() => `${prefixCls.value}-item-group`);
        return () => {
            var _a;
            return (<li {...attrs} onClick={e => e.stopPropagation()} class={groupPrefixCls.value}>
          <div title={typeof props.title === 'string' ? props.title : undefined} class={`${groupPrefixCls.value}-title`}>
            {getPropsSlot(slots, props, 'title')}
          </div>
          <ul class={`${groupPrefixCls.value}-list`}>{(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}</ul>
        </li>);
        };
    },
});
